import { render, staticRenderFns } from "./collectionHistory.vue?vue&type=template&id=644e9bde&"
import script from "./collectionHistory.vue?vue&type=script&lang=js&"
export * from "./collectionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports